import React, { useEffect, useRef } from 'react';
import ContentLayout from '../../layout/contentLayout';
import { useLocation, useNavigate } from 'react-router-dom';
import { handelCampainToken, handleReportsToken} from '../../constant/utils';
import { SetItemInStorage } from '../../custom_hooks/useStorage';
import { LocalStorage } from '../../custom_hooks/localStorageKeys';
import { config } from '../../constant';

const Reports = () => {

    const iframeRef = useRef<HTMLIFrameElement>(null);
    const env = import.meta.env.VITE_APP_ENV;
    const location = useLocation();
    const navigate = useNavigate();

    console.log('location?.state', location?.state)
    const encryptedToken = handleReportsToken();
    const sourceUrl: string = `${config().CAMPAIGN_URL}/cvmanalytics?cvm_data=${encryptedToken}`;
    // const sourceUrl: string = `http://192.168.11.195:4000/cvmcampaign?cvm_data=${encryptedToken}`;
    console.log('sourceUrl>>>>',sourceUrl)

    useEffect(() => {
  const handleMessage = (event :any) => {
    // Optionally check event.origin for security
    if (event.data?.type === "CVM_IFRAME") {    
      window.localStorage.setItem(LocalStorage.CVM_ANALYTICS, event?.data?.message?.data);
      console.log("Received message from parent:", event.data.message);
    
      // navigate('/campaigns',{state:{data:event.data.message}})
      navigate('/campaigns')
      // You can access the data like this
      const previewData = event.data.message?.data;
      console.log("Action Preview:", previewData);

      // Do something with previewData here...
    }
  };

  window.addEventListener("message", handleMessage);

  return () => {
    window.removeEventListener("message", handleMessage);
  };
}, []);

    return (

            <iframe
                id="smsCampaignFrame"
                ref={iframeRef}
                src={sourceUrl}
                style={{ width: "100%", height: "100%", border: 'none' }}
            />

        
    )
}

export default Reports
